import Vue from 'vue'
import Vuex from 'vuex'
import breakpoints from './modules/breakpoints'
import correlationId from './modules/correlationId'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    breakpoints,
    correlationId
  }
})
